import { UploadSource } from './UploadSource';

export type UploadMetadata = {
  organizationId: string;
  accountId: string;
  uploaderId: string;
  trackingId: string;
  source?: UploadSource;
  trigger?: string;
};

export const UploadMetadata = {
  new(meta: UploadMetadata): UploadMetadata {
    return {
      uploaderId: meta.uploaderId,
      organizationId: meta.organizationId,
      accountId: meta.accountId,
      trackingId: meta.trackingId,
      trigger: meta.trigger,
      // source should undefined if not valid
      source: UploadSource.new(meta.source),
    };
  },
};
